import '../ReusableComponents.css'
import '../ReusableDesign.css'
import hifi from '../../assets/nyt/nyt_hificrop.png'

export const DesignNyt = () => {
  return (
    <>
      <div className='BlackHeds white nyt'>
        <h2 className='h2_white cases_openerText'>Design</h2>
      </div>
      <section className='DesignContainer'>
        <div className='ButtonContainer'></div>
        <h4 className='h4 dropCap black nyt'>
          Building on the low fidelity feedback, I refined the grocery list
          interface by enlarging and moving the Edit/Done controls and aligning
          the deletion pattern with NYT&apos;s existing UI. I then tested the hi
          fi prototypes with 6 participants. 93% were satisfied with the serving
          size adjustment, praising the clear +/− controls. Grocery lists scored
          87%, and overall usability 87%. Participants still wanted inline
          editing to add or change items directly, but this functionality was
          beyond the project scope.
        </h4>
        <div className='ButtonContainer nyt1'>
          <div className='Button enlarge white'>high fidelity wireframes</div>
          <img className='competitive hi_fi nyt' src={hifi} alt={hifi} />
        </div>
      </section>
    </>
  )
}
